import React, { useState, useEffect, useRef } from "react";
import Layout, { Container } from "../components/layout";
import { useParams } from "react-router-dom";
import axios from "axios";
import { apiurl } from "../config/config";

const PurchaseOrderDetails = () => {
  const logoSrc = "/suwasthi-logo-brown.png"; // replace if needed
  const signSrc = "/assets/signature.jpg"; // using same file as placeholder

  const { poObjId } = useParams();
  const [poDetails, setPoDetails] = useState(null);
  const [loading, setLoading] = useState(true);


  const [showPaymentModal, setShowPaymentModal] = useState(false);
const [refreshKey, setRefreshKey] = useState(0);

const refreshPO = () => setRefreshKey((p) => p + 1);


  // useEffect(() => {
  //   axios
  //     .get(`${apiurl}/api/purchase-order/get/${poObjId}`)
  //     .then((res) => setPoDetails(res.data.data))
  //     .catch((err) => console.error("Error fetching supplier:", err))
  //     .finally(() => setLoading(false));
  // }, [poObjId]);

  useEffect(() => {
  setLoading(true);
  axios
    .get(`${apiurl}/api/purchase-order/get/${poObjId}`)
    .then((res) => setPoDetails(res.data.data))
    .finally(() => setLoading(false));
}, [poObjId, refreshKey]);


  const previewRef = useRef(null);

  // const handlePrint = () => {
  //   window.print();
  // };

  const handleGeneratePDF = async () => {
    // Try dynamic import of html2canvas and jspdf
    try {
      const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
        import("html2canvas"),
        import("jspdf"),
      ]);

      const element = previewRef.current;
      if (!element) return alert("Preview not ready");

      const canvas = await html2canvas(element, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save(`PO_${poDetails.poNumber || "PO"}.pdf`);
    } catch (err) {
      console.error("PDF generation failed:", err);
      // fallback to print
      window.print();
    }
  };

  const StatusBadge = ({ status }) => {
  const map = {
    Draft: "bg-gray-200 text-gray-800",
    Sent: "bg-blue-100 text-blue-700",
    Approved: "bg-green-100 text-green-700",
    Rejected: "bg-red-100 text-red-700",
    Paid: "bg-green-100 text-green-700",
    "Partially Paid": "bg-yellow-100 text-yellow-700",
    Unpaid: "bg-red-100 text-red-700",
  };
  return (
    <span
      className={`px-3 py-1 rounded-full text-xs font-semibold ${
        map[status] || "bg-gray-100"
      }`}
    >
      {status}
    </span>
  );
};


const ledger = poDetails?.ledger || [];

if (loading) {  
    return (
    <Layout>
      <Container>
        <div className="p-4">

          <p className="text-center text-gray-500">Loading purchase order...</p>
        </div>
      </Container>
    </Layout>
  );  
  }

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>

      <div className="max-w-6xl mx-auto space-y-4 pb-10">

  {/* HEADER */}
  <div className="bg-white rounded-xl shadow p-4 flex justify-between items-center">
    <div>
      <h2 className="text-xl font-semibold">
        Purchase Order #{poDetails?.poNumber}
      </h2>
      <div className="flex gap-2 mt-1">
        <StatusBadge status={poDetails?.status} />
        <StatusBadge
          status={poDetails?.paymentSummary?.paymentStatus}
        />
      </div>
    </div>

<div className="flex gap-2 justify-end">

      <button
    onClick={() => setShowPaymentModal(true)}
    className="px-4 py-2 rounded-lg bg-green-600 text-white text-sm"
  >
    + Add Payment
  </button>

    <button
      onClick={handleGeneratePDF}
      className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg"
    >
      Export PDF
    </button>
</div>

  </div>


<div className="bg-white rounded-xl shadow p-4">
  <h4 className="font-semibold mb-3">Supplier Ledger</h4>

  <table className="w-full text-sm">
    <thead className="bg-gray-100">
      <tr>
        <th className="p-2">Date</th>
        <th className="p-2">Type</th>
        <th className="p-2 text-right">Debit</th>
        <th className="p-2 text-right">Credit</th>
        <th className="p-2">Ref</th>
      </tr>
    </thead>
    <tbody>
      {ledger.length ? (
        ledger.map((l, i) => (
          <tr key={i} className="border-b">
            <td className="p-2">
              {new Date(l.date).toLocaleDateString()}
            </td>
            <td className="p-2">{l.type}</td>
            <td className="p-2 text-right text-red-600">
              {l.debit || "-"}
            </td>
            <td className="p-2 text-right text-green-600">
              {l.credit || "-"}
            </td>
            <td className="p-2">{l.ref}</td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="5" className="text-center p-4 text-gray-400">
            No ledger entries
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>


  {/* PARTY DETAILS */}
  <div className="grid grid-cols-2 gap-4">
    <div className="bg-white rounded-xl shadow p-4">
      <h4 className="font-semibold mb-2">Supplier</h4>
      <p className="font-medium">{poDetails?.supplier?.name}</p>
      <p className="text-sm text-gray-600">{poDetails?.supplier?.address}</p>
      <p className="text-sm mt-2">
        📞 {poDetails?.supplier?.contactPerson} –
        {poDetails?.supplier?.contactPersonPhone}
      </p>
    </div>

    <div className="bg-white rounded-xl shadow p-4">
      <h4 className="font-semibold mb-2">Ship To</h4>
      <p className="font-medium">{poDetails?.company?.name}</p>
      <p className="text-sm text-gray-600">{poDetails?.company?.address}</p>
    </div>
  </div>

  {/* ITEMS */}
  <div className="bg-white rounded-xl shadow p-4">
    <h4 className="font-semibold mb-2">Items</h4>
    <table className="w-full text-sm border">
      <thead className="bg-gray-50">
        <tr>
          <th className="border p-2">#</th>
          <th className="border p-2 text-left">Item</th>
          <th className="border p-2 text-right">Qty</th>
          <th className="border p-2 text-right">Rate</th>
          <th className="border p-2 text-right">Amount</th>
        </tr>
      </thead>
      <tbody>
        {poDetails?.items?.map((it, i) => (
          <tr key={i}>
            <td className="border p-2 text-center">{i + 1}</td>
            <td className="border p-2">{it.description}</td>
            <td className="border p-2 text-right">{it.quantity}</td>
            <td className="border p-2 text-right">₹{it.unitPrice}</td>
            <td className="border p-2 text-right">₹{it.total}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* AMOUNT SUMMARY */}
  <div className="grid grid-cols-2 gap-4">
    <div className="bg-white rounded-xl shadow p-4">
      <h4 className="font-semibold mb-2">Payment Summary</h4>
      <div className="space-y-1 text-sm">
        <div className="flex justify-between">
          <span>Total</span>
          <span>₹{poDetails?.totalAmount}</span>
        </div>
        <div className="flex justify-between">
          <span>Paid</span>
          <span className="text-green-600">
            ₹{poDetails?.paymentSummary?.totalPaid || 0}
          </span>
        </div>
        <div className="flex justify-between font-semibold">
          <span>Balance</span>
          <span className="text-red-600">
            ₹{poDetails?.paymentSummary?.balanceAmount || 0}
          </span>
        </div>
      </div>
    </div>

    {/* PAYMENTS */}
    <div className="bg-white rounded-xl shadow p-4">
      <h4 className="font-semibold mb-2">Payments</h4>
      {poDetails?.payments?.length ? (
        poDetails.payments.map((p, i) => (
          <div
            key={i}
            className="border rounded p-2 mb-2 text-sm flex justify-between"
          >
            <div>
              ₹{p.amount} – {p.mode}
              <div className="text-xs text-gray-500">
                {new Date(p.paymentDate).toLocaleDateString()}
              </div>
            </div>
            <span className="text-green-600 font-semibold">Received</span>
          </div>
        ))
      ) : (
        <p className="text-sm text-gray-500">No payments yet</p>
      )}
    </div>
  </div>

  {/* DEBIT / CREDIT NOTES */}
  <div className="bg-white rounded-xl shadow p-4">
    <h4 className="font-semibold mb-2">Debit / Credit Notes</h4>
    {poDetails?.adjustments?.length ? (
      poDetails.adjustments.map((a, i) => (
        <div
          key={i}
          className="border rounded p-2 mb-2 text-sm flex justify-between"
        >
          <span>
            {a.type} – ₹{a.amount}
            <div className="text-xs text-gray-500">{a.reason}</div>
          </span>
          <StatusBadge status={a.type} />
        </div>
      ))
    ) : (
      <p className="text-sm text-gray-500">No adjustments</p>
    )}
  </div>
</div>

<AddPaymentModal
  open={showPaymentModal}
  onClose={() => setShowPaymentModal(false)}
  poId={poDetails?._id}
  refresh={refreshPO}
/>


        {/* <div className="mt-4 p-2 flex gap-2">
          <button
            type="button"
            className="bg-indigo-600 text-white px-4 py-2 rounded"
            onClick={handleGeneratePDF}
          >
            Export PDF
          </button>
        </div> */}
        <div
          ref={previewRef}
          className="p-2"
          style={{ width: "800px", background: "white", color: "#111" }}
        >
          <div className="border p-4">
            {/* Header */}
            <div className="flex justify-between items-start mb-4">
              <div>
                <img
                  src={logoSrc}
                  alt="logo"
                  className="h-20 mx-auto mb-2"
                  // style={{ width: 110, height: 110, objectFit: "contain" }}
                />
              </div>
              <div className="text-center">
                <h2 className="text-[18px] capitalize font-bold">
                  SUWASTHI INTENSE HEALTHCARE PRIVATE LIMITED
                </h2>
                {/* <div className="text-sm">{company.address}</div> */}
                <p className="text-[12px]">
                  SITE-V, I-021, KASNA INDUSTRIAL AREA, GREATER NOIDA,
                </p>
                <p className="text-[12px]">GAUTAM BUDDHA NAGAR (UP) 201308</p>
                <div className="text-[12px] font-semibold">
                  GSTIN: 09AAYCS2840M1ZH
                </div>
              </div>

              <div></div>
            </div>
            <div className="grid grid-cols-3 text-sm border mb-2">
              <div className="py-1 pl-1 border-r">
                <strong className="text-[12px]">
                  PO Number:- {poDetails?.poNumber}
                </strong>
              </div>
              <div className="py-1 pl-1 border-r">
                <strong className="text-[12px]">
                  PO Date:- {poDetails?.poDate}
                </strong>
              </div>
              <div className="py-1 pl-1">
                <strong className="text-[12px]">
                  Mode of Transport:- {poDetails?.transportMode}
                </strong>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-2 mb-3 text-sm ">
              <div className="border p-2">
                <strong className="text-[14px]">Supplier Name:</strong>
                <div className="capitalize text-[14px]">
                  {poDetails?.supplier?.name || "-"}
                </div>
                <div className="capitalize text-[14px]">
                  {poDetails?.supplier?.address || "-"}
                </div>
                <strong className="mt-2 block text-[14px]">
                  Contact Details:
                </strong>
                <div>{poDetails?.supplier?.contactPerson || "-"}</div>
                <div> {poDetails?.supplier?.contactPersonPhone || "-"}</div>
              </div>

              <div className="border p-2">
                <strong>Ship To:</strong>
                <div className="capitalize">
                  {poDetails?.company?.name || "Default Name"}
                </div>
                <div className="text-sm capitalize">
                  {poDetails?.company?.address || "Default Address"}
                </div>
                <strong className="mt-2 block">Contact Details:</strong>
                <div>{poDetails?.company?.contactPerson}</div>
                <div> {poDetails?.company?.contactPersonPhone}</div>
              </div>
            </div>

            {/* Items Table */}
            <div className="mb-3">
              <table className="min-w-full border">
                <thead className="bg-gray-100 text-sm">
                  <tr>
                    <th className="p-2 border">S.No</th>
                    <th className="p-2 border">Name</th>
                    <th className="p-2 border">Quantity (Unit)</th>
                    <th className="p-2 border">Prices (Rs) per Unit</th>
                    <th className="p-2 border">Total prices (Rs)</th>
                    <th className="p-2 border">GST (in Rs)</th>
                    <th className="p-2 border">Amount with GST</th>
                  </tr>
                </thead>
                <tbody>
                  {poDetails?.items.map((it, idx) => {
                    const qty = parseFloat(it.quantity) || 0;
                    const price = parseFloat(it.unitPrice) || 0;
                    const total = qty * price;
                    const gstForLine =
                      (total * (parseFloat(it.igst) || 0)) / 100;
                    const amtWithGst = total + gstForLine;

                    return (
                      <tr key={idx}>
                        <td className="p-2 border text-center capitalize text-sm">
                          {idx + 1}
                        </td>
                        <td className="p-2 border capitalize text-sm">
                          {it.description || "-"}
                        </td>
                        <td className="p-2 border text-right text-sm">{qty}</td>
                        <td className="p-2 border text-right text-sm">
                          {price}
                        </td>
                        <td className="p-2 border text-right text-sm">
                          {total}
                        </td>
                        <td className="p-2 border text-right text-sm">
                          {gstForLine}
                        </td>
                        <td className="p-2 border text-right text-sm">
                          {amtWithGst}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Totals */}
            <div className="flex justify-end">
              <div style={{ width: 360 }}>
                <div className="flex justify-between border p-2">
                  <div>Subtotal</div>
                  <div>₹ {poDetails?.subtotal}</div>
                </div>
                <div className="flex justify-between border-x p-2">
                  <div>GST Total</div>
                  <div>₹ {poDetails?.tax}</div>
                </div>
                <div className="flex justify-between border p-2 font-bold">
                  <div>Grand Total</div>
                  <div>₹ {poDetails?.totalAmount}</div>
                </div>
              </div>
            </div>

            <div className="mt-3 text-sm italic font-bold">
              {poDetails?.rupeesInWords}
            </div>

            <div className="mt-4">
              <strong className="text-sm">Terms & Conditions:</strong>
              <div className="text-[12px] mt-1 whitespace-pre-wrap">
                {poDetails?.terms}
              </div>
            </div>

            <div className="mt-8 flex justify-between items-end">
              {/* Left - Signature */}
              <div className="flex flex-col items-start">
                <img
                  src={signSrc}
                  alt="signature"
                  className="w-28 object-contain"
                />
                <div className="text-sm mt-2">Authorised Signatory</div>
              </div>

              {/* Right - Company Info */}
              <div className="text-right text-sm flex flex-col items-end space-y-1">
                <div>
                  <strong>For: </strong>
                  <span className="uppercase">{poDetails?.supplier?.name}</span>
                </div>
                <div>
                  <strong>Prepared By: </strong>
                  {poDetails?.company?.name}
                </div>
                <div>{poDetails?.company?.address}</div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </Layout>
  );
};

export default PurchaseOrderDetails;


const AddPaymentModal = ({ open, onClose, poId, refresh }) => {
  const [form, setForm] = useState({
    amount: "",
    mode: "Bank",
    referenceNo: "",
  });

  if (!open) return null;

  const submit = async () => {
    if (!form.amount) return alert("Enter amount");

    await axios.post(
      `${apiurl}/api/purchase-order/${poId}/add-payment`,
      form
    );

    refresh();
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
      <div className="bg-white rounded-xl p-5 w-96 space-y-3">
        <h3 className="font-semibold text-lg">Add Payment</h3>

        <input
          placeholder="Amount"
          type="number"
          className="border p-2 w-full rounded"
          onChange={(e) =>
            setForm({ ...form, amount: +e.target.value })
          }
        />

        <select
          className="border p-2 w-full rounded"
          onChange={(e) =>
            setForm({ ...form, mode: e.target.value })
          }
        >
          <option>Bank</option>
          <option>UPI</option>
          <option>Cash</option>
          <option>NEFT</option>
        </select>

        <input
          placeholder="Reference No"
          className="border p-2 w-full rounded"
          onChange={(e) =>
            setForm({ ...form, referenceNo: e.target.value })
          }
        />

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded"
          >
            Cancel
          </button>
          <button
            onClick={submit}
            className="bg-indigo-600 text-white px-4 py-2 rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
